import { useAthosContext } from '../fetchers/provider'
import { useEffect } from 'preact/hooks'
import { useIntersectionObserver } from './useIntersectionObserver'

export function useFilterScroll() {
  const { options } = useAthosContext()
  const sorts = options.get('sort')
  const { setNode: setScrollElement, entry: scrollStartElement } = useIntersectionObserver({ threshold: 0.1 })

  useEffect(() => {
    if (scrollStartElement?.isIntersecting === false || scrollStartElement?.boundingClientRect?.top < window.scrollY) {
      const offset = 100
      const scrollToPosition = window.scrollY + scrollStartElement.boundingClientRect.top - offset
      window.scrollTo({ top: Math.max(0, scrollToPosition), behavior: 'instant' })
    }
  }, [sorts])

  return { setScrollElement }
}
